import React from "react";
import MapSection from "../component/MapSection";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import ContactForm from "./ContactForm";
import { useSiteConfig } from "../context/SiteConfigContext";


const ContactUs = () => {
  const {siteConfig} = useSiteConfig();
  console.log(siteConfig)

  return (
    <>
      {/* hero section */}
      <BreadCrumbBanner
        title="Contact Us"
         backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* contact page */}
      <section className="mrv-contact-section">
        <div className="container">
          {/* Heading */}
          <div className="text-left mb-3">
            <span className="mrv-subtitle">Get In Touch</span>
            <h2 className="mrv-title">Contact Us</h2>
          </div>
          <div className="row g-4 align-items-stretch">
            {/* LEFT : RED CONTACT INFO */}
            <div className="col-lg-5 d-flex px-0">
              <div className="contact-info-box w-100">
                <h4>Reach Us</h4>
                <p>
                  Feel free to contact us for admissions, school details, or
                  general queries.
                </p>
                <div className="contact-info-item">
                  <i className="bi bi-geo-alt-fill" />
                  <div>
                    <h6>Address</h6>
                    <span>
                      {siteConfig.address}
                    </span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <i className="bi bi-telephone-fill" />
                  <div>
                    <h6>Landline Numbers</h6>
                    <span>{siteConfig.landline1}, {siteConfig.landline2}</span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <i className="bi bi-telephone-fill" />
                  <div>
                    <h6>Mobile Number</h6>
                    <span>{siteConfig.phone}</span>
                  </div>
                </div>

                
                <div className="contact-info-item">
                  <i className="bi bi-envelope-fill" />
                  <div>
                    <h6>Email</h6>
                    <span>{siteConfig.email}</span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <i className="bi bi-clock-fill" />
                  <div>
                    <h6>School Hours</h6>
                    <span>{siteConfig?.schoolhours}</span>
                  </div>
                </div>
              </div>
            </div>
            {/* RIGHT : FORM */}
            <div className="col-lg-7 d-flex">
              <div className="contact-form-box w-100">
               <ContactForm/>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* MAP SECTION */}
      <MapSection />
      
    </>
  );
};

export default ContactUs;
